/**
 * Utility function to download PDF from base64 encoded data
 * @param {string} base64String - The base64 encoded PDF data
 * @param {string} fileName - The name of the file to download
 */
export const downloadPdfFromBase64 = (base64String, fileName = 'document.pdf') => {
  if (!base64String) {
    console.error('No base64 string provided');
    return;
  }

  try {
    // Remove data:application/pdf;base64, prefix if present
    const cleanBase64 = base64String.replace(/^data:application\/pdf;base64,/, '');
    
    // Convert base64 string to binary data
    const binaryString = atob(cleanBase64);
    const bytes = new Uint8Array(binaryString.length);
    
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    
    // Create a blob from the binary data
    const blob = new Blob([bytes], { type: 'application/pdf' });
    
    // Create a URL for the blob
    const url = URL.createObjectURL(blob);
    
    // Create an anchor element and trigger download
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    
    // Clean up: remove the link and revoke the URL
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading PDF from base64:', error);
  }
};

/**
 * React hook for downloading PDF from base64
 * @returns {Object} - Object with downloadPdf function
 */
export const usePdfDownload = () => {
  const downloadPdf = (base64String, fileName = 'document.pdf') => {
    downloadPdfFromBase64(base64String, fileName);
  };

  return { downloadPdf };
};
